module.exports = __webpack_public_path__ + "static/Ice_Hockey-e5d74090d04e44c0dbd79a10bff07457.mp4";